import CTPLFormReview from "../../components/organisms/CTPL/review";

const CTPLFormReviewPage = () =>{
    return <CTPLFormReview />
};
export default CTPLFormReviewPage;